import React from 'react';
import { withTranslation } from 'react-i18next';

import { withStyles } from '@material-ui/styles';
import InputAdornment from '@material-ui/core/InputAdornment';

import MbInput from 'components/atoms/MbInput';
import Icon from 'components/atoms/Icon';

const styles = () => ({});

class RevenuePointTextBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.defaultValue,
    };
  }

  componentDidMount() {}

  onChange = () => (e) => {
    const { defaultValue } = this.state;

    if (e.target.value !== defaultValue) {
      this.setState({
        value: e.target.value,
      });
    }
  };

  onBlur = () => (e) => {
    const { defaultValue } = this.state;

    if (e.target.value !== defaultValue) {
      this.props.handleOnBlurText(
        this.props.orderNumber,
        e.target.value,
        this.props.paramsKey
      );
    }
  };

  render() {
    const { onChange, onBlur } = this;
    const { value } = this.state;
    const { paramsKey, hasIcon = false } = this.props;

    let icon;
    if (hasIcon) {
      icon = {
        startAdornment: (
          <InputAdornment position="start">
            <Icon icon={'faWonSign'} color="#8D9BA2" style={{ fontSize: 14 }} />
          </InputAdornment>
        ),
      };
    } else {
      icon = false;
    }

    return (
      <div>
        <MbInput
          name={paramsKey}
          value={value}
          onChange={onChange()}
          onBlur={onBlur()}
          margin="normal"
          style={{
            width: '100%',
            maxWidth: 200,
            margin: 0,
            height: 35,
          }}
          InputProps={icon}
        />
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(RevenuePointTextBox));
